import React, { useState } from 'react';  
import { Card, Row, Col, Space, Checkbox, Radio } from 'antd';  
import { PieChartOutlined, InfoCircleOutlined, BarChartOutlined } from '@ant-design/icons';  
const AddonCard = (props) => { 
  const [selected, setSelected] = useState(false);
  
  const changeCardSelect = ()=> {
    if(props.selectedCardId != props.addon.id){
      props.setSelectedCardId(props.addon.id);
    } 
  };
  return (  
    <Card style={{ width: '100%', borderWidth: (props.selectedCardId == props.addon.id ? '3px' : "0.5px"), borderRadius: '8px', borderColor: (props.selectedCardId == props.addon.id ? "#1890ff" : "lightgray"), backgroundColor: (props.selectedCardId == props.addon.id ? "rgb(221, 237, 252)" : "transparent")}} onClick={changeCardSelect} hoverable>  
      <Row gutter={[32, 32]}>  
        <Col span={1} style={{ display: 'flex', padding: 0}}>  
          <div style={{backgroundImage: 'url(../../../../vitria.svg)', width: '100%', height: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}}></div>
        </Col>  
        <Col span={23}>  
          <Space direction="vertical" style={{ width: '100%' }}>  
            <h3 style={{ margin: 0, color: 'blue', textDecoration: 'underline'}}><strong>{props.addon.name}</strong></h3>  
            <p style={{ margin: '4px 0', color: '#595959' }}><strong>{props.addon.desc}</strong></p>  
            <Row gutter={[16, 8]} justify="space-between">  
              <Col span={8}>  
                <Row gutter={[8, 0]}>  
                  <Col><InfoCircleOutlined style={{ fontSize: '16px', color: '#1890ff' }} /></Col>  
                  <Col><span>Catetory</span><br /><span><strong>{props.addon.category}</strong></span></Col>  
                </Row>  
              </Col>  
              <Col span={8}>  
                <Row gutter={[8, 0]}>  
                  <Col><BarChartOutlined style={{ fontSize: '16px', color: '#1890ff' }} /></Col>  
                  <Col><span>Version</span><br /><span><strong>{props.addon.version}</strong></span></Col>  
                </Row>  
              </Col>  
              <Col span={8}>  
                <Row gutter={[8, 0]}>  
                  <Col><PieChartOutlined style={{ fontSize: '16px', color: '#1890ff' }} /></Col>  
                  <Col><span>Status</span><br /><span><strong>{props.addon.status}</strong></span></Col>  
                </Row>  
              </Col>  
            </Row>  
          </Space>  
        </Col>
        {/* <Col span={1} offset={-1} style={{ textAlign: 'right' }}>  
          <Radio checked={props.addon.id == props.selectedCardId} onChange={changeCardSelect}/>
        </Col>     */}
      </Row>  
    </Card>  
  );  
};  
  
export default AddonCard;

